/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconNight16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconNight16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                d="M8.508 2.002a5.658 5.658 0 0 0-1.19 3.48 5.66 5.66 0 0 0 .748 2.825l.004.007.004.008c.038.065.078.129.12.192a5.644 5.644 0 0 0 5.559 2.58 5.997 5.997 0 0 1-2.169 2.145 5.81 5.81 0 0 1-2.887.76L8.691 14a5.963 5.963 0 0 1-3.658-1.223 6.018 6.018 0 0 1-2.157-3.215 6.049 6.049 0 0 1 .242-3.872A6.006 6.006 0 0 1 5.66 2.773v-.001a5.87 5.87 0 0 1 2.849-.77Z"
                stroke="currentColor"
                strokeWidth="1.333"
            />
        </SVGContainer>
    );
});

const IconNight24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconNight24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                d="M12.765 3.001a8.486 8.486 0 0 0-1.788 5.222 8.49 8.49 0 0 0 1.028 4.062v.001c.03.059.063.116.095.174l.011.021c.056.095.114.189.173.28v.002a8.466 8.466 0 0 0 8.346 3.88 8.997 8.997 0 0 1-3.254 3.214A8.717 8.717 0 0 1 13.046 21h-.01a8.942 8.942 0 0 1-5.486-1.835 9.027 9.027 0 0 1-3.236-4.822 9.072 9.072 0 0 1 .364-5.808 9.011 9.011 0 0 1 3.804-4.374l.001.001a8.805 8.805 0 0 1 4.282-1.161Z"
                stroke="currentColor"
                strokeWidth="2"
            />
        </SVGContainer>
    );
});

export const IconNight = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconNight(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '16':
            return <IconNight16 {...iconProps} />;
        case '24':
            return <IconNight24 {...iconProps} />;
        default:
            return <IconNight24 {...iconProps} />;
    }
});
